var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.data && _vm.props.data.value)?_c('span',[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.props.data && _vm.props.data.value,'M/d/yyyy'))+" UTC ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }